import styled from 'styled-components';

export const SimpleTableRow = styled.tr`
	&:last-child {
		td {
			border-bottom: 0;
		}
	}
`;

export const DownloadButton = styled.div`
	${props => !props.disabled && 'cursor: pointer;'};
`;
